import { Router } from "@frui.ts/screens";

export default class AppRouter extends Router {}
